export default "__VITE_ASSET__DJspXqe6__"